import { Guid } from "@syncfusion/ej2/pdf-export";

export class careCordinatorList {
    id: Guid;
    agencyId: Guid;
    coordinator_Name: string;
    county: string;
    phoneNumber: string;
    fax: string;
    alternateFax: string;
    email: string = "";
}
export class searchfilterDetails {
    Filter_Telephone: string;
    Filter_Fax: string;
    Filter_Alternate_Fax: string;
    Filter_County: string;
    Filter_careCoordinatorName: string;
}
export class sortingObj {
    itemperpage: number = 20;
    currentPgNo: number = 1;
    shortcolumn: string = "Coordinator_Name";
    shortType: string = 'asc';
}
export class functionpermission {
    carecoordinatorcreate: boolean = true;
    carecoordinatordelete: boolean = true;
    carecoordinatorupdate: boolean = true;

}
export class WhereCondition {
    field: string = "Coordinator_Name";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}
export class GetCareListBo {
    SearchColumn: string = "Coordinator_Name";
    SearchText: string = "";
    orderColumn: string = "Coordinator_Name";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    // userId: number = 0;
    field: string = "Coordinator_Name";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    AgencyId: Guid;
}